
export default [
  {
    path: '/',
    redirect: '/home',
    meta: {
      notCache: true
    }
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '首页',
      notCache: true
    },
    component: () => import('@/views/home/home')
  }]



// WEBPACK FOOTER //
// ./src/router/routers.js